import {
  useAssignLessonTagMutation,
  useLessonTagsQuery,
  useTagsQuery,
  useUnassignLessonTagMutation,
} from '../../api/tagApi';
import { useClientContext } from '../../hooks/useClientContext';
import { TagPickerView } from './TagPickerView';

export interface LessonTagPickerProps {
  lessonId: string;
  disabled?: boolean;
}

export function LessonTagPicker({ lessonId, disabled = false }: LessonTagPickerProps) {
  const { clientContext } = useClientContext();
  const { data: itemTags } = useLessonTagsQuery(lessonId);
  const { data: library } = useTagsQuery({ assignedAccountId: clientContext?.id });
  const assignMutation = useAssignLessonTagMutation(lessonId);
  const unassignMutation = useUnassignLessonTagMutation(lessonId);

  return (
    <TagPickerView
      tags={itemTags?.items ?? []}
      allTags={library?.items ?? []}
      countKey="lessonCount"
      onAssign={(tagId) => assignMutation.mutate(tagId)}
      onUnassign={(tagId) => unassignMutation.mutate(tagId)}
      disabled={disabled}
    />
  );
}
